import React from 'react';
import { withRouter } from 'react-router';
import Configurer from '../../components/Configurer';
// import { checkTextTranslation } from '../../utils/useful'
import FormViewer from '../../components/FormViewer';
import LoaderButton from '../../components/LoaderButton';
import Responsive from '../../components/Responsive';
import { checkTranslation, fetchWallpaper, imageAddress, pathMaker, translate } from '../../utils/useful';
import { siteConfig, siteTheme } from '../../variables/config';
import { QRCode } from 'react-qrcode-logo';
import ModernBg1 from '../../components/ModernBg1';


class CFSuccess extends React.Component {

    state = {

    }

    // componentDidMount() {
    //     this.props.showHeader(false)
    // }

    componentDidMount() {
        this.props.showHeader(true, () => {

            if (this.props.setHeader) {
                // this.props.setHeader("dummy",1)
                this.props.setHeader({
                    'toolbar': null,
                    'showToolbar': false,
                    // 'title': `${this.props.user?.info?.fullname}`,
                    isPortal: true, doNotshowNotification: true,
                    showSettings: false,
                    create: true,
                    'title': "{{lang}}Frame created successfully",
                    topHeaderComponent: null,
                    // backAction: () => this.props.lastStage()
                })
            }
        })
    }

    // nextStage = (cb) => {
    //     // this.setState({ isLoading: true, errors: {} })
    //     if (this.form) {
    //         let data = this.form.getForm()
    //         if (data) {
    //             this.props.setData(data, () => {
    //                 // this.props.postUserInfo((result, err) => {
    //                 // if (err) { this.setState({ errors: err }) }
    //                 // this.setState({ isLoading: false })
    //                 this.props.chooseNextPage()

    //                 // })
    //             })
    //         }
    //     }
    // }

    openFrame = () => {
        // console.log(this.props.createdFrame?.hub?.username, this.props.createdFrame?.applet?.slug, 'admin', (this.props.createdFrame?.slug ?? this.props.createdFrame?._id))
        // let test = ['unibe.ac', 'admin', "6699c4c39e4cc2035c1bcfc0"]
        this.props.changeWindow([this.props.createdFrame?.hub?.username, this.props.createdFrame?.applet?.slug, 'admin', (this.props.createdFrame?.slug ?? this.props.createdFrame?._id)])
        // this.props.changeWindow(test)

    }



    render() {

        let link = siteConfig.rootDomain + this.props.createdFrame?.hub?.username + '/' + this.props.createdFrame?.applet?.slug + '/admin/' + (this.props.createdFrame?.slug ?? this.props.createdFrame?._id)
        return (

            <div className=" w-100 h-100   position-relative" style={{}}>
                <div className="position-absolute top-0 left-0 w-100 h-100 overflow-hidden pointer-none">
                    <div className="w-100 h-100 overflow-hidden">
                        <div style={{ height: 500, width: 500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgb(255 252 51 / 15%) 0%, rgba(255, 0, 235, 0) 100%)' }}></div>
                        <div style={{ height: 500, width: 500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgb(51 191 255 / 10%) 0%, rgba(128, 255, 0, 0) 100%)' }}></div>

                    </div>
                </div>
                <div className='d-flex w-100 h-100 '>

                    <Responsive width={this.props.width} height="100%" media={{ xs: "12", }}>
                        <div className='h-100 w-100 flexc flex-column scroll-no-scrollbar' style={{ padding: '0px 4%' }}>
                            <div className='w-100 flexcc' style={{ paddingTop: '3%' }}>

                                <div className="flexc flex-column mb-4 w-100" style={{ maxWidth: 700, transition: 'all 0.5s', flex: '1 1 auto', padding: '30px 20px 60px 20px', backgroundColor: '#ffffff', borderRadius: 12 }}>

                                    {/* <div className="w-100 pt-5 flexc flex-column"> */}
                                    <div className="w-100 flexc flex-column" style={{ maxWidth: 500, paddingTop: '4vh' }}>
                                        {/* <img src={'/images/fireworks.svg'} width="80px" /> */}

                                        <QRCode onClick={() => this.openFrame()} quietZone={0} value={link} size="120" title={link} logoImage={'/assets/logo-c.jpg'} removeQrCodeBehindLogo={true} logoWidth={28} qrStyle={'dots'} eyeRadius={[[10, 10, 0, 10], [10, 10, 10, 0], [10, 0, 10, 10],]} eyeColor={'#303030'} enableCORS={true} ecLevel="Q" />
                                        {/* <p onClick={() => this.openFrame()}  className='mt-2 color-gray-2 text-semibold text-normal'>@{this.props.initData.username}</p> */}

                                        <h1 className="text-big mt-2">{checkTranslation(this.props.initData.name) + ' ' + translate('frame')}</h1>
                                        <h2 className="text-semibig mb-2  mt-0">{translate('ca.Created Successfully')}</h2>
                                        <p className="mb-4 text-small text-center" style={{ maxWidth: 350 }}>{translate('The frame created successfully. Now you can access it using the following address.')}</p>
                                        <div className='w-100 px-3'>
                                            <div className='py-2 px-3 mb-4 flexcb w-100' style={{ backgroundColor: '#f2f6f8', borderRadius: 10, border: '1px solid #f0f0f0' }}>

                                                <button className='w-100 text-start' style={{ maxWidth: 'calc(100% - 20px)' }} onClick={() => this.openFrame()} >
                                                    <p className=" text-small  text-semibold w-100" style={{ textOverflow: 'ellipsis', overflow: 'hidden', color: '#6764FE', whiteSpace: 'nowrap' }}>{link}</p>
                                                </button>
                                                <img className='mld-2' src={'/assets/icons/useful/duplicate.svg'} width="20px" style={{ opacity: 0.3 }} />
                                            </div>
                                        </div>

                                        <div className='flexc'>
                                            <button onClick={() => this.openFrame()} className='px-1 py-1  flexcc' style={{ background: 'linear-gradient(to right, #6764FE, #8C64FE)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Go to frame")}</p>
                                                <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 10 }}>
                                                    <img className='invert' src='/assets/icons/useful/eye.svg' height={18} />
                                                </div>
                                            </button>


                                            {/* <button onClick={() => this.props.visitApplet()} className='px-1 py-1 mx-1 flexcc' style={{ filter: 'saturate(40%)', background: 'linear-gradient(to right, #6764FE, #8C64FE)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                <div className='flexcc  p-1' style={{ borderRadius: 10 }}>
                                                    <img className='invert' src='/assets/icons/useful/share.svg' height={18} />
                                                </div>
                                            </button> */}

                                        </div>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </Responsive>

                    {/* <Responsive width={this.props.width} height="100%" media={{ xs: "none", sm: '4', md: '4', lg: "6", xl: "6" }}>

                        <div className="text-center" style={{ minHeight: '100vh', position: 'relative', top: 0, padding: '100px 30px 20px 30px', backgroundPosition: 'center', backgroundSize: 'cover' }}>


                            <div className='flexc flex-column' style={{ position: 'sticky', top: 70 }}>
                                <img className=" mb-2" src={'/assets/icons/portals/Asset 2.svg'} width={'90px'} />
                                <p className="text-big text-bold">{translate("Create Hub").toUpperCase()}</p>
                                <p className=" text-smaller" style={{ maxWidth: '300px' }} >{translate("Description about new hub and the terms of use will be shown here")}</p>
                            </div>
                        </div>

                    </Responsive> */}


                </div>
            </div>

        )
    }
}


export default withRouter(CFSuccess)